var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as R from 'ramda';
import { isObject } from '@tencent/gems-shared';
/**
 * 解析带有$row的表达式
 * 1: $row.order_id，表示获取当前行的内容，会根据indexList的值组装成类似${#66[#44.$index].dataSource[$index].order_id}这种格式
 * 2: $row.$row.order_info，表示获取当前行的上一级迭代的当前行
 * 最后会把$index直接替换成对应的index真实值
 * @param rowExpression 带有$row的表达式
 * @param iterator 迭代器
 */
export var parseDollarRowIterator = function (rowExpr, iterator) {
    var indexList = iterator === null || iterator === void 0 ? void 0 : iterator.indexList;
    if (!indexList || indexList.length === 0) {
        return rowExpr;
    }
    var items = __spreadArray([], __read(iterator === null || iterator === void 0 ? void 0 : iterator.indexList));
    var matchRows = rowExpr.match(/\.\$row/g);
    if (matchRows && (matchRows === null || matchRows === void 0 ? void 0 : matchRows.length) > 0 && items.length > 1) {
        var parentRowCount = matchRows === null || matchRows === void 0 ? void 0 : matchRows.length;
        var deleteCount = parentRowCount < indexList.length ? parentRowCount : 0;
        items = items.slice(0, items.length - deleteCount);
    }
    var parentIndexs = [];
    for (var i = 0; i < items.length - 1; i++) {
        var item = items[i];
        parentIndexs.push("[" + item.index + "]");
    }
    var lastItem = items[items.length - 1];
    var expression = "stores[" + lastItem.key + "]" + parentIndexs.join('') + ".dataSource[" + lastItem.index + "]";
    return rowExpr.replace(/\$row(.\$row)?/g, expression);
};
var parseIterator = function (expression, iterator) {
    var result = expression;
    if ((iterator === null || iterator === void 0 ? void 0 : iterator.indexList) && iterator.indexList.length > 1) {
        iterator.indexList.forEach(function (item) {
            var searchValue = "#" + item.key + ".$index";
            searchValue = result.indexOf(searchValue) >= 0 ? searchValue : '$index';
            result = result.replace(searchValue, item.index);
        });
    }
    else if (iterator && !R.isNil(iterator === null || iterator === void 0 ? void 0 : iterator.index)) {
        result = result.replace(/\$index/g, iterator === null || iterator === void 0 ? void 0 : iterator.index.toString());
    }
    return result;
};
var containsDollarRow = function (expression) {
    return expression.indexOf('$row') >= 0;
};
/**
 * @description: 计算表达式，将变量解析出来，再进行执行表达式
 * @param {string} expression 表达式，含变量
 * 变量：自身变量 =》 ${text}
 *      用key为44的组件的变量 =》 ${#44.text}
 * 表达式：${text > 2 && "text" || #3.val} 被${}包裹
 *        自身变量 =》text
 *        key为3组件的变量#3.val
 * 字符串拼接：aaa${text}33
 *           aaa${text ? "1" : "3"}44
 * @param {SchemaHandlerParams} params 处理schema需要的辅助数据
 * @return {any} 表达式解析出来的任意值，有报错则输出为表达式模版
 */
export function evalExpression(expression, params) {
    var rootStore = params.rootStore, storeId = params.storeId, iterator = params.iterator, global = params.global;
    var rootState = rootStore.getState();
    var exprReg = /\$\{(.)+\}/;
    // 判断是否符合变量标准
    if (!expression || typeof expression !== 'string' || !exprReg.test(expression)) {
        return expression;
    }
    var finalExpresson = expression; // 赋初始值
    try {
        var exprCharReg = /(?:#)(\d+)(\.|\[.+\])/g; // 匹配#3.
        // 将#4.val 替换成stores[4].val
        finalExpresson = expression.replace(exprCharReg, function (m, p1, p2) {
            return "stores[" + p1 + "]" + p2;
        });
        // 匹配迭代器
        finalExpresson = containsDollarRow(expression)
            ? parseDollarRowIterator(finalExpresson, iterator)
            : parseIterator(finalExpresson, iterator);
        // 如果配置的表达式是从global取数据，需要把$global替换成global
        finalExpresson = finalExpresson.replace(/\$global/g, 'global');
        // 使得模版字符串解析生效
        var exprGlobalReg = /^(\$\{)((?!\$\{).)*(\})$/g; // 全局只有${}包裹
        // 判断是否是纯模版 eg:${sss}
        if (exprGlobalReg.test(finalExpresson)) {
            finalExpresson = finalExpresson.slice(2, finalExpresson.length - 1);
        }
        else {
            finalExpresson = "`" + finalExpresson + "`";
        }
        // 构造该变量可通过模版字符串解析的数据域
        var dataRegion = __assign({ global: global, stores: rootState }, rootState[storeId]);
        // eslint-disable-next-line no-new-func
        var fn = new Function('data', "with(data) {return " + finalExpresson + "}");
        return fn(dataRegion);
    }
    catch (e) {
        return '';
    }
}
/**
 * @description: 获取当前schema属性所依赖的storeKey
 * @param {any} content schema内容
 * @return {number[]}
 */
export function getStoreKeyByExpression(content, iterator) {
    var _a;
    if (containsDollarRow(content)) {
        return (_a = iterator === null || iterator === void 0 ? void 0 : iterator.indexList) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            return item.key.toString();
        });
    }
    // fix: safari不支持后向引用
    var regex = /#(\d+)(?=\.|\[\d+\])/g; // 数字后面可能是.可能是数组
    // const regex = /(?<=#)(\d+)|(?=(\.|(\[\d+\])))/g; // 数字后面可能是.可能是数组
    var matches = content.match(regex) || [];
    return matches.map(function (m) { return m.replace('#', ''); });
}
/**
 * @description: 循环处理schema，解析数据中所有表达式以及拿到依赖storeKey
 * @param {any} data schema
 * @param {SchemaHandlerParams} params 处理schema需要的辅助数据
 * @return {any}
 */
export function handleSchema(data, params) {
    var storeId = params.storeId, parseExpression = params.parseExpression, iterator = params.iterator;
    if (!isObject(data)) {
        return { data: data, storeIds: ["" + storeId] };
    }
    var relativeStoreIds = []; // 记录最终相关storeIds
    var resolveData = __assign(__assign({}, data), { iterator: iterator });
    Object.keys(data).forEach(function (key) {
        var value = data[key];
        if (typeof value === 'string') {
            var storeKeys = getStoreKeyByExpression(value, params.iterator);
            if (storeKeys) {
                relativeStoreIds = relativeStoreIds.concat(storeKeys);
            }
            // 加上是否是EXPR_前缀的判断，将其在到达组件前修复组装
            if (/^(EXPR_)/.test(key)) {
                // 在编辑态不需解析data
                resolveData[key.slice(5)] = parseExpression ? evalExpression(value, params) : value;
                // 删除expr无用属性
                delete resolveData[key];
            }
            return;
        }
        if (Array.isArray(value)) {
            // 当是数组的时候循环递归执行
            resolveData[key] = value.map(function (d) {
                var _a = handleSchema(d, params), newData = _a.data, storeIds = _a.storeIds;
                relativeStoreIds = relativeStoreIds.concat(storeIds);
                return newData;
            });
            return;
        }
        if (isObject(value)) {
            // 当是对象的时候递归执行
            var _a = handleSchema(value, params), newData = _a.data, storeIds = _a.storeIds;
            relativeStoreIds = relativeStoreIds.concat(storeIds);
            resolveData[key] = newData;
            return;
        }
        resolveData[key] = value;
    });
    // 加入自身store的state并去重
    relativeStoreIds = Array.from(new Set(relativeStoreIds.concat(["" + storeId])));
    return {
        data: resolveData,
        storeIds: relativeStoreIds,
    };
}
//# sourceMappingURL=tpl.js.map